export const pagesKey = ['pages'];
export const sellerPagesKey = (sellerId = null) => ['pages', sellerId];
export const sellerPagesKeyWithFilter = (sellerId = null, filter = null) =>
  filter ? ['pages', sellerId, filter] : ['pages', sellerId];

export const pageKey = pageId => ['pages', pageId];
export const pageCheckoutsKey = filter => ['pages', 'checkouts', filter];
export const pageFormsKey = filter => ['pages', 'forms', filter];
export const pageTicketTypesKey = pageId => ['pages', 'ticket-types', pageId];

export const templatesKey = ['templates'];
export const templateKey = templateId => ['templates', templateId];

export const templateCategoriesKey = ['templates-categories'];
export const templateCategoryKey = templateCategoryId => [
  'templates-categories',
  templateCategoryId,
];

export const integrationsKey = ['integrations'];
export const integrationKey = integrationId => ['integrations', integrationId];
export const integrationsPageKey = pageId => ['integrations-page', pageId];
export const integrationEventsKey = integrationId => ['integration', integrationId, 'events'];

export const customerKey = customerId => ['customers', customerId];

export const submissionKey = submissionId => ['submissions', submissionId];
export const submissionEmailLogsKey = submissionId => ['submissions', submissionId, 'email-logs'];

export const couponsKey = (sort, filter) => ['coupons', sort, filter];
export const couponKey = couponId => ['coupons', couponId];

export const sellerKey = sellerId => ['sellers', sellerId];
export const adminSellerKey = sellerId => ['admin-sellers', sellerId];
export const eventDashboardOverviewKey = eventId => ['event-dashboard-overview', eventId];
export const sellerBillingAddress = sellerId => ['seller-billing-address', sellerId];
export const sellerPlansKey = sellerId => ['seller-plans', sellerId];
export const sellerGoogleKey = sellerId => ['seller-oauthGoogleAccounts', sellerId];
export const sellerSlackKey = sellerId => ['seller-oauthSlackAccounts', sellerId];

export const chargeKey = chargeId => ['charges', chargeId];
export const chargeInvoicesKey = chargeId => ['charges', chargeId, 'invoices'];
export const chargeEmailLogsKey = chargeId => ['charges', chargeId, 'email-logs'];
export const chargeTicketsKey = chargeId => ['charges', chargeId, 'tickets'];
export const chargeTransactionsKey = chargeId => ['charges', chargeId, 'transactions'];

export const subscriptionKey = subscriptionId => ['subscriptions', subscriptionId];
export const subscriptionPaymentsKey = subscriptionPaymentId => [
  'subscriptionPayments',
  subscriptionPaymentId,
];
export const subscriptionEmailLogsKey = subscriptionId => [
  'subscriptions',
  subscriptionId,
  'email-logs',
];

export const statisticKey = ({ metric, sellerId, dateStart, dateEnd, unit, timezoneOffset }) => [
  'statistics',
  metric,
  sellerId,
  dateStart,
  dateEnd,
  unit,
  timezoneOffset,
];

export const recentCustomersKey = sellerId => ['seller-recent-customers', sellerId];
export const recentPaymentsKey = sellerId => ['seller-recent-payments', sellerId];
export const recentSubscriptionsKey = sellerId => ['seller-recent-subscriptions', sellerId];
export const recentSubmissionsKey = sellerId => ['seller-recent-submissions', sellerId];

export const domainStatusKey = domain => ['domain-status', domain];

export const teamMembersKey = ['team-members'];

export const apiKeysKey = sellerId => ['apiKeys', sellerId];

export const webhooksKey = (sellerId, filters = {}) => ['webhooks', sellerId, filters];
